import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import AnalyticsTab from "../../components/admin/tabs/AnalyticsTab";
import AdminLayout from "../../components/admin/AdminLayout";
import useAdminData from "../../hooks/useAdminData";
import useAdminActions from "../../hooks/useAdminActions";

const AdminAnalyticsPage = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  const handleCoursesChange = () => {
    // Refresh data if needed
  };

  // Use custom hooks
  const adminData = useAdminData(user);

  const formatDate = (dateString) => {
    if (!dateString) return "Nunca";
    return new Date(dateString).toLocaleString("pt-BR");
  };
  const adminActions = useAdminActions(user, handleCoursesChange, () => {
    // Refresh all data
    adminData.fetchUsers();
    adminData.fetchGroups();
    adminData.fetchCertificates();
    adminData.fetchVideoAccess();
    adminData.fetchCourseProgress();
    adminData.fetchAdminCourses();
  });

  return (
    <AdminLayout user={user} onLogout={handleLogout} title="Relatórios de Acesso">
      <AnalyticsTab
        videoAccess={adminData.videoAccess}
        loading={adminData.loading}
        error={adminData.error}
        videoAccessPagination={adminData.videoAccessPagination}
        onFetchVideoAccess={adminData.fetchVideoAccess}
        analyticsSearchTerm={adminData.analyticsSearchTerm}
        setAnalyticsSearchTerm={adminData.setAnalyticsSearchTerm}
        formatDate={formatDate}
      />
    </AdminLayout>
  );
};

export default AdminAnalyticsPage;
